export default __webpack_public_path__ + "static/media/mayaDeleCruz.83ed80b9.png";